import type { Assistant } from "@inrev/assistant";
import type { AssistantChartDataId, AssistantConversationId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { assistantChartDataQueryKey } from "../assistant.keys";

/**
 * Structured data a tool assembled for a panel component, such as `ask_org_chart`'s structure.
 * apps/api checks it against `Turn.ChartData` before serving it. A stored chart never changes.
 */
export const useFetchAssistantChartData = (
	conversationId: AssistantConversationId,
	chartId: AssistantChartDataId,
) => {
	const { get } = useRequest();

	return useQuery({
		queryKey: assistantChartDataQueryKey(chartId),
		queryFn: async () =>
			get<Assistant.Dtos.Agent.Turn.ChartData>(
				`/v2/admin/assistant/conversations/${conversationId}/chart-data/${chartId}`,
			),
		staleTime: Number.POSITIVE_INFINITY,
	});
};
